import React from 'react';
import { Spinner } from '@phosphor-icons/react';

/**
 * Lightweight content-area loader shown while a lazily-loaded route chunk is
 * being fetched. Rendered INSIDE the app shell (TopBar / nav stay mounted), so
 * navigating between pages never unmounts the shell — no full-screen flicker.
 */
export default function PageFallback() {
  return (
    <div className="flex items-center justify-center py-24 w-full" data-testid="page-loading">
      <Spinner size={28} className="animate-spin text-[#6B4D5F]" />
    </div>
  );
}
